import { QBankStructureLevelCategory } from '@exam-management/graphql';

import type { QuestionReviewTaskCreationFormInput } from '../providers';

export const EMPTY_LOCATION = {
  [QBankStructureLevelCategory.Part]: null,
  [QBankStructureLevelCategory.Subject]: null,
  [QBankStructureLevelCategory.Group]: null,
  [QBankStructureLevelCategory.Chapter]: null,
  [QBankStructureLevelCategory.Topic]: null,
  [QBankStructureLevelCategory.SubTopic]: null,
};

export const EMPTY_QUESTION = {
  questionId: {},
};

export const QUESTION_REVIEW_TASK_CREATION_FORM_DEFAULT_VALUES: Partial<QuestionReviewTaskCreationFormInput> =
  {
    taskName: undefined,
    courseId: undefined,
    location: EMPTY_LOCATION,
    question: EMPTY_QUESTION,
  };
